"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _H = _interopRequireDefault(require("UIComponents/elements/headings/H4"));

var _UIIllustration = _interopRequireDefault(require("UIComponents/image/UIIllustration"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _useResponsiveProps = require("ecosystem-marketplace-core/hooks/useResponsiveProps");

var _calloutBlobs = _interopRequireDefault(require("bender-url!ecosystem-marketplace-apps-ui/img/callout-blobs.svg"));

var _calloutWave = _interopRequireDefault(require("bender-url!ecosystem-marketplace-apps-ui/img/callout-wave.svg"));

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  padding: ", " ", " ", "\n    ", ";\n  overflow: hidden;\n  background-color: ", ";\n  background-image: url(", "),\n    linear-gradient(\n      -303deg,\n      ", ",\n      ", "\n    );\n  background-position: top right;\n  background-repeat: no-repeat;\n  background-size: auto 110%;\n  color: ", ";\n\n  &::after {\n    content: '';\n    display: block;\n    height: ", "px;\n    width: 110%;\n    position: absolute;\n    left: -5%;\n    right: -5%;\n    bottom: -", "px;\n    background-image: url(", ");\n    background-repeat: no-repeat;\n    background-size: 100% 100%;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var WAVE_HEIGHT = 100;
var HeroSection = (0, _styledComponents.default)(function (props) {
  return _react.default.createElement(_UICardSection.default, (0, _extends2.default)({}, props, {
    scrollable: true
  }));
}).withConfig({
  displayName: "AbstractCallout__HeroSection",
  componentId: "wkh8ld-0"
})(_templateObject(), _sizes.CARD_PADDING_COMPACT, _sizes.CARD_PADDING, _sizes.CARD_PADDING, _sizes.CARD_PADDING_COMPACT, function (props) {
  return props.primaryBackgroundColor;
}, _calloutBlobs.default, function (props) {
  return props.primaryBackgroundColor;
}, function (props) {
  return props.secondaryBackgroundColor;
}, _colors.OLAF, WAVE_HEIGHT, WAVE_HEIGHT / 2, _calloutWave.default);

var AbstractCallout = function AbstractCallout(_ref) {
  var className = _ref.className,
      footer = _ref.footer,
      illustrationName = _ref.illustrationName,
      multi = _ref.multi,
      primaryBackgroundColor = _ref.primaryBackgroundColor,
      secondaryBackgroundColor = _ref.secondaryBackgroundColor,
      subheader = _ref.subheader,
      title = _ref.title;
  var headerBoxResponsiveProps = (0, _useResponsiveProps.useResponsiveProps)({
    basis: {
      xs: '100%',
      sm: '65%'
    }
  });
  var illustrationBoxResponsiveProps = (0, _useResponsiveProps.useResponsiveProps)({
    basis: {
      xs: '100%',
      sm: '35%'
    }
  });
  return _react.default.createElement(_UICardWrapper.default, {
    className: className,
    compact: true
  }, _react.default.createElement(HeroSection, {
    primaryBackgroundColor: primaryBackgroundColor,
    secondaryBackgroundColor: secondaryBackgroundColor
  }, _react.default.createElement(_UIFlex.default, {
    align: "start",
    wrap: "wrap"
  }, _react.default.createElement(_UIBox.default, headerBoxResponsiveProps, _react.default.createElement(_H.default, {
    className: "m-bottom-2"
  }, title), !multi ? subheader : null), _react.default.createElement(_UIBox.default, (0, _extends2.default)({}, illustrationBoxResponsiveProps, {
    className: "text-center"
  }), _react.default.createElement(_UIIllustration.default, {
    className: "m-left-10",
    height: 100,
    name: illustrationName
  })))), _react.default.createElement(_UICardSection.default, {
    className: "p-top-0",
    compact: true
  }, footer));
};

AbstractCallout.propTypes = {
  className: _propTypes.default.string,
  footer: _propTypes.default.node.isRequired,
  illustrationName: _propTypes.default.string.isRequired,
  multi: _propTypes.default.bool,
  primaryBackgroundColor: _propTypes.default.string.isRequired,
  secondaryBackgroundColor: _propTypes.default.string.isRequired,
  subheader: _propTypes.default.node.isRequired,
  title: _propTypes.default.node.isRequired
};
AbstractCallout.defaultProps = {
  multi: false
};
var _default = AbstractCallout;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/callouts/AbstractCallout.js
// module id = 443
// module chunks = 209 210 211 212